module.exports = __webpack_public_path__ + "static/media/eye.590bdd0c.svg";